// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

common.View.create('canvas.blocks.custom.portfolioSlider.Block', {
    onDOMLoad() {
        this.initSwipers();
    },

    swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2.25,
                spaceBetween: 32,
            },
            1024: {
                slidesPerView: 3.25,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    },

    initSwipers() {
        // Initialize the all swipers within the .swipers container
        const swiperContainers = this.element.find('.swipers .swiper').get();

        // Loop swiper containers and initialize each swiper
        swiperContainers.forEach((container) => {
            new Swiper(container, this.swiperOptions);
        });

        // init category swiper on all screen sizes
        new Swiper('.categorySwiper', {
            slidesPerView: 'auto',
            spaceBetween: 16,
        });
    },

    // Old
    initSwiper() {
        const swiperInstance = new Swiper('.portfolioSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 2.25,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 3.25,
                    spaceBetween: 32,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        Alpine.store('portfolioSlider', {
            swiper: swiperInstance,
        });
    
        // init category swiper only on mobile
        if (window.innerWidth < 1024) {
            new Swiper('.categorySwiper', {
                slidesPerView: 'auto',
                spaceBetween: 8,
            });
        }
    },
});
